import {
  Directive,
  Input,
  OnInit,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { PermissionService } from 'src/app/core/services/permission.service';

@Directive({
  selector: '[appCheckPermission]',
})
export class PermissionDirective {
  private permissions: string[] = [''];
  private s11User: string[] = ['S11 Controller', 'S11 Commander'];
  private s11permissions: string[] = [
    'Dealer',
    'Checker',
    ...this.s11User,
  ];

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private permission: PermissionService,
  ) {}

  @Input()
  set appCheckPermission(val: string[]) {
    if (val.includes('S11User')) {
      this.permissions = [...val, ...this.s11User];
    } else if (val.includes('S11Permissions')) {
      this.permissions = [...val, ...this.s11permissions];
    } else {
      this.permissions = val;
    }
    this.updateView();
  }

  private async updateView() {
    const hasPermission = await this._checkPermission();
    if (hasPermission) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }

  private _checkPermission() {
    return this.permission.checkAccess(this.permissions);
  }
}
